module.exports = __webpack_public_path__ + "static/img/2.1d95133.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/2.png
// module id = WXis
// module chunks = 0